import {object, array, number, string} from 'yup';
import {messages} from '../../../../utils/messages';
import {PURCHASE_MIN_MONEY} from '../../../../business/keys';
import {ProductShape, currencyCode} from './product';

// Export schema
export const productAddPaymentInfo = object().shape({
  currencyCode,
  paymentType: string().ensure(),
  paymentInstallments: string().optional().ensure(),
  actionField: object().shape({
    revenue: number().min(PURCHASE_MIN_MONEY, messages.MIN_NUM),
  }).noUnknown(messages.NO_UNKNOWN),
  products: array().of(object().shape(ProductShape)).required(
    'productAddPaymentInfo requires an array of products.',
  ),
}).noUnknown(messages.NO_UNKNOWN);
